export const API_AUTH_LOGIN_REQUEST = 'API_AUTH_LOGIN_REQUEST';
export const API_AUTH_LOGIN_SUCCESS = 'API_AUTH_LOGIN_SUCCESS';
export const API_AUTH_LOGIN_FAILURE = 'API_AUTH_LOGIN_FAILURE';
export const API_AUTH_LOGOUT_REQUEST = 'API_AUTH_LOGOUT_REQUEST';
export const API_AUTH_LOGOUT_SUCCESS = 'API_AUTH_LOGOUT_SUCCESS';
export const API_AUTH_LOGOUT_FAILURE = 'API_AUTH_LOGOUT_FAILURE';
export const API_AUTH_REGISTER_REQUEST = 'API_AUTH_REGISTER_REQUEST';
export const API_AUTH_REGISTER_SUCCESS = 'API_AUTH_REGISTER_SUCCESS';
export const API_AUTH_REGISTER_FAILURE = 'API_AUTH_REGISTER_FAILURE';
export const API_AUTH_REFRESH_REQUEST = 'API_AUTH_REFRESH_REQUEST';
export const API_AUTH_REFRESH_SUCCESS = 'API_AUTH_REFRESH_SUCCESS';
export const API_AUTH_REFRESH_FAILURE = 'API_AUTH_REFRESH_FAILURE';
export const API_AUTH_TOKEN_LOADING_COMPLETE = 'API_AUTH_TOKEN_LOADING_COMPLETE';
export const AUTH_HANDLE_PROFILE = 'AUTH_HANDLE_PROFILE';

export const LOGOUT = 'LOGOUT';
export const COOKIE_POLL_INTERVAL = 300 * 1000; // 5m

export const TOGGLE_TIMEOUT_MODAL = 'TOGGLE_TIMEOUT_MODAL';
export const TOGGLE_PROFILE_UPDATE_MODAL = 'TOGGLE_PROFILE_UPDATE_MODAL';

export const API_COMMENT_GET_REQUEST = 'API_COMMENT_GET_REQUEST';
export const API_COMMENT_GET_SUCCESS = 'API_COMMENT_GET_SUCCESS';
export const API_COMMENT_GET_FAILURE = 'API_COMMENT_GET_FAILURE';
export const API_COMMENT_POST_REQUEST = 'API_COMMENT_POST_REQUEST';
export const API_COMMENT_POST_SUCCESS = 'API_COMMENT_POST_SUCCESS';
export const API_COMMENT_POST_FAILURE = 'API_COMMENT_POST_FAILURE';

export const API_HISTORY_GET_REQUEST = 'API_HISTORY_GET_REQUEST';
export const API_HISTORY_GET_SUCCESS = 'API_HISTORY_GET_SUCCESS';
export const API_HISTORY_GET_FAILURE = 'API_HISTORY_GET_FAILURE';

export const API_ORG_GET_BY_ID_REQUEST = 'API_ORG_GET_BY_ID_REQUEST';
export const API_ORG_GET_BY_ID_SUCCESS = 'API_ORG_GET_BY_ID_SUCCESS';
export const API_ORG_GET_BY_ID_FAILURE = 'API_ORG_GET_BY_ID_FAILURE';
export const API_ORG_GET_BY_DUNS_REQUEST = 'API_ORG_GET_BY_DUNS_REQUEST';
export const API_ORG_GET_BY_DUNS_SUCCESS = 'API_ORG_GET_BY_DUNS_SUCCESS';
export const API_ORG_GET_BY_DUNS_FAILURE = 'API_ORG_GET_BY_DUNS_FAILURE';

export const API_ORG_GET_BY_UEIEFT_REQUEST = 'API_ORG_GET_BY_UEIEFT_REQUEST';
export const API_ORG_GET_BY_UEIEFT_SUCCESS = 'API_ORG_GET_BY_UEIEFT_SUCCESS';
export const API_ORG_GET_BY_UEIEFT_FAILURE = 'API_ORG_GET_BY_UEIEFT_FAILURE';
export const API_ORG_SEARCH_ON_DBA_LEGALNAME_REQUEST =
  'API_ORG_SEARCH_ON_DBA_LEGALNAME_REQUEST';
export const API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS =
  'API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS';
export const API_ORG_SEARCH_ON_DBA_LEGALNAME_FAILURE =
  'API_ORG_SEARCH_ON_DBA_LEGALNAME_FAILURE';
export const API_CREATE_UPDATE_ORG_REQUEST = 'API_CREATE_UPDATE_ORG_REQUEST';
export const API_CREATE_UPDATE_ORG_SUCCESS = 'API_CREATE_UPDATE_ORG_SUCCESS';
export const API_CREATE_UPDATE_ORG_FAILURE = 'API_CREATE_UPDATE_ORG_FAILURE';

export const API_CREATE_ORG_REQUEST = 'API_CREATE_ORG_REQUEST';
export const API_CREATE_ORG_SUCCESS = 'API_CREATE_ORG_SUCCESS';
export const API_CREATE_ORG_FAILURE = 'API_CREATE_ORG_FAILURE';

export const API_CREATE_SUB_ORG_REQUEST = 'API_CREATE_SUB_ORG_REQUEST';
export const API_CREATE_SUB_ORG_SUCCESS = 'API_CREATE_SUB_ORG_SUCCESS';
export const API_CREATE_SUB_ORG_FAILURE = 'API_CREATE_SUB_ORG_FAILURE';

export const API_ADD_SUB_ORG_REQUEST = 'API_ADD_SUB_ORG_REQUEST';
export const API_ADD_SUB_ORG_SUCCESS = 'API_ADD_SUB_ORG_SUCCESS';
export const API_ADD_SUB_ORG_FAILURE = 'API_ADD_SUB_ORG_FAILURE';

export const API_ORG_GET_ALL_SUBORGS_REQUEST = 'API_ORG_GET_ALL_SUBORGS_REQUEST';
export const API_ORG_GET_ALL_SUBORGS_SUCCESS = 'API_ORG_GET_ALL_SUBORGS_SUCCESS';
export const API_ORG_GET_ALL_SUBORGS_FAILURE = 'API_ORG_GET_ALL_SUBORGS_FAILURE';

export const API_LINK_APP_TO_VENDOR_REQUEST = 'API_LINK_APP_TO_VENDOR_REQUEST';
export const API_LINK_APP_TO_VENDOR_SUCCESS = 'API_LINK_APP_TO_VENDOR_SUCCESS';
export const API_LINK_APP_TO_VENDOR_FAILURE = 'API_LINK_APP_TO_VENDOR_FAILURE';

export const API_ATTACHMENT_UPLOAD_REQUEST = 'API_ATTACHMENT_UPLOAD_REQUEST';
export const API_ATTACHMENT_UPLOAD_SUCCESS = 'API_ATTACHMENT_UPLOAD_SUCCESS';
export const API_ATTACHMENT_UPLOAD_FAILURE = 'API_ATTACHMENT_UPLOAD_FAILURE';
export const API_ATTACHMENT_GET_REQUEST = 'API_ATTACHMENT_GET_REQUEST';
export const API_ATTACHMENT_GET_SUCCESS = 'API_ATTACHMENT_GET_SUCCESS';
export const API_ATTACHMENT_GET_FAILURE = 'API_ATTACHMENT_GET_FAILURE';
export const API_ATTACHMENT_DELETE_REQUEST = 'API_ATTACHMENT_DELETE_REQUEST';
export const API_ATTACHMENT_DELETE_SUCCESS = 'API_ATTACHMENT_DELETE_SUCCESS';
export const API_ATTACHMENT_DELETE_FAILURE = 'API_ATTACHMENT_DELETE_FAILURE';
// for updating attachment metadata, not the file itself
export const API_ATTACHMENT_UPDATE_REQUEST = 'API_ATTACHMENT_UPDATE_REQUEST';
export const API_ATTACHMENT_UPDATE_SUCCESS = 'API_ATTACHMENT_UPDATE_SUCCESS';
export const API_ATTACHMENT_UPDATE_FAILURE = 'API_ATTACHMENT_UPDATE_FAILURE';

export const API_CONFIG_GET_REQUEST = 'API_CONFIG_GET_REQUEST';
export const API_CONFIG_GET_SUCCESS = 'API_CONFIG_GET_SUCCESS';
export const API_CONFIG_GET_FAILURE = 'API_CONFIG_GET_FAILURE';

export const API_RULES_GET_REQUEST = 'API_RULES_GET_REQUEST';
export const API_RULES_GET_SUCCESS = 'API_RULES_GET_SUCCESS';
export const API_RULES_GET_FAILURE = 'API_RULES_GET_FAILURE';

export const API_EHP_GET_REQUEST = 'API_EHP_GET_REQUEST';
export const API_EHP_GET_SUCCESS = 'API_EHP_GET_SUCCESS';
export const API_EHP_GET_FAILURE = 'API_EHP_GET_FAILURE';

export const API_VENDOR_GET_REQUEST = 'API_VENDOR_GET_REQUEST';
export const API_VENDOR_GET_SUCCESS = 'API_VENDOR_GET_SUCCESS';
export const API_VENDOR_GET_FAILURE = 'API_VENDOR_GET_FAILURE';

export const API_CONTEXT_GET_REQUEST = 'API_CONTEXT_GET_REQUEST';
export const API_CONTEXT_GET_SUCCESS = 'API_CONTEXT_GET_SUCCESS';
export const API_CONTEXT_GET_FAILURE = 'API_CONTEXT_GET_FAILURE';

export const API_PROFILE_GET_REQUEST = 'API_PROFILE_GET_REQUEST';
export const API_PROFILE_GET_SUCCESS = 'API_PROFILE_GET_SUCCESS';
export const API_PROFILE_GET_FAILURE = 'API_PROFILE_GET_FAILURE';
export const API_PROFILE_PUT_REQUEST = 'API_PROFILE_PUT_REQUEST';
export const API_PROFILE_PUT_SUCCESS = 'API_PROFILE_PUT_SUCCESS';
export const API_PROFILE_PUT_FAILURE = 'API_PROFILE_PUT_FAILURE';
export const API_PROFILE_PATCH_REQUEST = 'API_PROFILE_PATCH_REQUEST';
export const API_PROFILE_PATCH_SUCCESS = 'API_PROFILE_PATCH_SUCCESS';
export const API_PROFILE_PATCH_FAILURE = 'API_PROFILE_PATCH_FAILURE';

export const API_ALL_TOGGLES_REQUEST = 'API_ALL_TOGGLES_REQUEST';
export const API_ALL_TOGGLES_SUCCESS = 'API_ALL_TOGGLES_SUCCESS';
export const API_ALL_TOGGLES_FAILURE = 'API_ALL_TOGGLES_FAILURE';

export const CLEAR_ALL_MSG = 'CLEAR_ALL_MSG';
export const ADD_MSG = 'ADD_MSG';
export const REMOVE_MSG = 'REMOVE_MSG';

export const SAVE_ENTITY_DATA = 'SAVE_ENTITY_DATA';
export const CLEAR_ENTITY_DATA = 'CLEAR_ENTITY_DATA';

export const TRIGGER_DIRTY_MAP = 'TRIGGER_DIRTY_MAP';
export const VALIDATE_CONFIG_RULES_RUNNING = 'VALIDATE_CONFIG_RULES_RUNNING';
export const SET_VALIDATION_CONFIGURATION = 'SET_VALIDATION_CONFIGURATION';
export const VALIDATE_CONFIG_RULES_FINISHED = 'VALIDATE_CONFIG_RULES_FINISHED';

export const SAVE_SECTION_STATUSES = 'SAVE_SECTION_STATUSES';

export const DYNAMIC_COMPONENT_INIT = 'DYNAMIC_COMPONENT_INIT';
export const DYNAMIC_COMPONENT_INIT_WITH_STATE = 'DYNAMIC_COMPONENT_INIT_WITH_STATE';
export const DYNAMIC_COMPONENT_NAV_CHILD = 'DYNAMIC_COMPONENT_NAV_CHILD';
export const DYNAMIC_COMPONENT_NAV_PARENT = 'DYNAMIC_COMPONENT_NAV_PARENT';
export const DYNAMIC_COMPONENT_NAV_SIBLING_NEXT = 'DYNAMIC_COMPONENT_NAV_SIBLING_NEXT';
export const DYNAMIC_COMPONENT_NAV_SIBLING_PREV = 'DYNAMIC_COMPONENT_NAV_SIBLING_PREV';
export const DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION =
  'DYNAMIC_COMPONENT_NAV_SPECIFIC_LOCATION';
export const DYNAMIC_COMPONENT_NAV_NEXT = 'DYNAMIC_COMPONENT_NAV_NEXT';
export const DYNAMIC_COMPONENT_SAVE_DATA = 'DYNAMIC_COMPONENT_SAVE_DATA';
export const DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES =
  'DYNAMIC_COMPONENT_SAVE_DATA_BASED_TITLES';
export const DYNAMIC_COMPONENT_SAVE_DATA_ERROR = 'DYNAMIC_COMPONENT_SAVE_DATA_ERROR';
export const DYNAMIC_COMPONENT_CLEAN_DATA = 'DYNAMIC_COMPONENT_CLEAN_DATA';
export const API_CLOSEOUT_GET_REQUEST = 'API_CLOSEOUT_GET_REQUEST';
export const API_CLOSEOUT_GET_SUCCESS = 'API_CLOSEOUT_GET_SUCCESS';
export const API_CLOSEOUT_GET_FAILURE = 'API_CLOSEOUT_GET_FAILURE';

export const API_SUBAWARDREC_GET_REQUEST = 'API_SUBAWARDREC_GET_REQUEST';
export const API_SUBAWARDREC_GET_SUCCESS = 'API_SUBAWARDREC_GET_SUCCESS';
export const API_SUBAWARDREC_GET_FAILURE = 'API_SUBAWARDREC_GET_FAILURE';

export const API_SUBGRANT_GET_REQUEST = 'API_SUBGRANT_GET_REQUEST';
export const API_SUBGRANT_GET_SUCCESS = 'API_SUBGRANT_GET_SUCCESS';
export const API_SUBGRANT_GET_FAILURE = 'API_SUBGRANT_GET_FAILURE';

export const API_AWARDREC_PUT_REQUEST = 'API_AWARDREC_PUT_REQUEST';
export const API_AWARDREC_PUT_SUCCESS = 'API_AWARDREC_PUT_SUCCESS';
export const API_AWARDREC_PUT_FAILURE = 'API_AWARDREC_PUT_FAILURE';

export const API_GRANT_BY_NUMBER_GET_REQUEST = 'API_GRANT_BY_NUMBER_GET_REQUEST';
export const API_GRANT_BY_NUMBER_GET_SUCCESS = 'API_GRANT_BY_NUMBER_GET_SUCCESS';
export const API_GRANT_BY_NUMBER_GET_FAILURE = 'API_GRANT_BY_NUMBER_GET_FAILURE';

export const API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_REQUEST =
  'API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_REQUEST';
export const API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS =
  'API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS';
export const API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE =
  'API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE';

export const DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST =
  'DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST';
export const DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS =
  'DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS';
export const DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE =
  'DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE';

export const API_PANEL_SCORES_POST_REQUEST = 'API_PANEL_SCORES_POST_REQUEST';
export const API_PANEL_SCORES_POST_SUCCESS = 'API_PANEL_SCORES_POST_SUCCESS';
export const API_PANEL_SCORES_POST_FAILURE = 'API_PANEL_SCORES_POST_FAILURE';

export const SNAPSHOT_POST_REQUEST = 'SNAPSHOT_POST_REQUEST';
export const SNAPSHOT_POST_SUCCESS = 'SNAPSHOT_POST_SUCCESS';
export const SNAPSHOT_POST_FAILURE = 'SNAPSHOT_POST_FAILURE';

export const API_TASK_COMPLETE_REQUEST = 'API_TASK_COMPLETE_REQUEST';
export const API_TASK_COMPLETE_SUCCESS = 'API_TASK_COMPLETE_SUCCESS';
export const API_TASK_COMPLETE_FAILURE = 'API_TASK_COMPLETE_FAILURE';
export const CLEAR_COMPLETED_TASK = 'CLEAR_COMPLETED_TASK';

export const API_TASK_ASSIGN_POST_REQUEST = 'API_TASK_ASSIGN_POST_REQUEST';
export const API_TASK_ASSIGN_POST_SUCCESS = 'API_TASK_ASSIGN_POST_SUCCESS';
export const API_TASK_ASSIGN_POST_FAILURE = 'API_TASK_ASSIGN_POST_FAILURE';

export const API_TASK_UNASSIGN_REQUEST = 'API_TASK_UNASSIGN_REQUEST';
export const API_TASK_UNASSIGN_SUCCESS = 'API_TASK_UNASSIGN_SUCCESS';
export const API_TASK_UNASSIGN_FAILURE = 'API_TASK_UNASSIGN_FAILURE';

export const API_TASK_UPDATE_POST_REQUEST = 'API_TASK_UPDATE_POST_REQUEST';
export const API_TASK_UPDATE_POST_SUCCESS = 'API_TASK_UPDATE_POST_SUCCESS';
export const API_TASK_UPDATE_POST_FAILURE = 'API_TASK_UPDATE_POST_FAILURE';

export const API_ACC_RESET_PW_REQUEST = 'API_ACC_RESET_PW_REQUEST';
export const API_ACC_RESET_PW_SUCCESS = 'API_ACC_RESET_PW_SUCCESS';
export const API_ACC_RESET_PW_FAILURE = 'API_ACC_RESET_PW_FAILURE';

export const TEMPLATE_GET_REQUEST = 'TEMPLATE_GET_REQUEST';
export const TEMPLATE_GET_SUCCESS = 'TEMPLATE_GET_SUCCESS';
export const TEMPLATE_GET_FAILURE = 'TEMPLATE_GET_FAILURE';

export const DYNAMIC_DATA_GET_REQUEST = 'DYNAMIC_DATA_GET_REQUEST';
export const DYNAMIC_DATA_GET_SUCCESS = 'DYNAMIC_DATA_GET_SUCCESS';
export const DYNAMIC_DATA_GET_FAILURE = 'DYNAMIC_DATA_GET_FAILURE';
export const DYNAMIC_DATA_POST_REQUEST = 'DYNAMIC_DATA_POST_REQUEST';
export const DYNAMIC_DATA_POST_SUCCESS = 'DYNAMIC_DATA_POST_SUCCESS';
export const DYNAMIC_DATA_POST_FAILURE = 'DYNAMIC_DATA_POST_FAILURE';
export const DYNAMIC_DATA_GET_ENTITY_REQUEST = 'DYNAMIC_DATA_GET_ENTITY_REQUEST';
export const DYNAMIC_DATA_GET_ENTITY_SUCCESS = 'DYNAMIC_DATA_GET_ENTITY_SUCCESS';
export const DYNAMIC_DATA_GET_ENTITY_FAILURE = 'DYNAMIC_DATA_GET_ENTITY_FAILURE';

export const API_APPLICATION_GET_REQUEST = 'API_APPLICATION_GET_REQUEST';
export const API_APPLICATION_GET_SUCCESS = 'API_APPLICATION_GET_SUCCESS';
export const API_APPLICATION_GET_FAILURE = 'API_APPLICATION_GET_FAILURE';

export const API_ASSIGN_APPLICATION_TO_CHAIR_REQUEST =
  'API_ASSIGN_APPLICATION_TO_CHAIR_REQUEST';
export const API_ASSIGN_APPLICATION_TO_CHAIR_SUCCESS =
  'API_ASSIGN_APPLICATION_TO_CHAIR_SUCCESS';
export const API_ASSIGN_APPLICATION_TO_CHAIR_FAILURE =
  'API_ASSIGN_APPLICATION_TO_CHAIR_FAILURE';

export const API_UNASSIGN_APPLICATION_FROM_CHAIR_REQUEST =
  'API_UNASSIGN_APPLICATION_FROM_CHAIR_REQUEST';
export const API_UNASSIGN_APPLICATION_FROM_CHAIR_SUCCESS =
  'API_UNASSIGN_APPLICATION_FROM_CHAIR_SUCCESS';
export const API_UNASSIGN_APPLICATION_FROM_CHAIR_FAILURE =
  'API_UNASSIGN_APPLICATION_FROM_CHAIR_FAILURE';

export const API_RISK_ASSESSMENT_POST_REQUEST = 'API_RISK_ASSESSMENT_POST_REQUEST';
export const API_RISK_ASSESSMENT_POST_SUCCESS = 'API_RISK_ASSESSMENT_POST_SUCCESS';
export const API_RISK_ASSESSMENT_POST_FAILURE = 'API_RISK_ASSESSMENT_POST_FAILURE';

export const COMMITMENT_GET_REQUEST = 'COMMITMENT_GET_REQUEST';
export const COMMITMENT_GET_SUCCESS = 'COMMITMENT_GET_SUCCESS';
export const COMMITMENT_GET_FAILURE = 'COMMITMENT_GET_FAILURE';

export const API_SAMGOV_GET_REQUEST = 'API_SAMGOV_GET_REQUEST';
export const API_SAMGOV_GET_SUCCESS = 'API_SAMGOV_GET_SUCCESS';
export const API_SAMGOV_GET_FAILURE = 'API_SAMGOV_GET_FAILURE';

export const API_ORG_GET_BY_USER_REQUEST = 'API_ORG_GET_BY_USER_REQUEST';
export const API_ORG_GET_BY_USER_SUCCESS = 'API_ORG_GET_BY_USER_SUCCESS';
export const API_ORG_GET_BY_USER_FAILURE = 'API_ORG_GET_BY_USER_FAILURE';

export const API_ORG_GET_BY_DUNS_FROM_SAMGOV_REQUEST =
  'API_ORG_GET_BY_DUNS_FROM_SAMGOV_REQUEST';
export const API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS =
  'API_ORG_GET_BY_DUNS_FROM_SAMGOV_SUCCESS';
export const API_ORG_GET_BY_DUNS_FROM_SAMGOV_FAILURE =
  'API_ORG_GET_BY_DUNS_FROM_SAMGOV_FAILURE';

export const API_PROGRAM_LIST_GET_REQUEST = 'API_PROGRAM_LIST_GET_REQUEST';
export const API_PROGRAM_LIST_GET_SUCCESS = 'API_PROGRAM_LIST_GET_SUCCESS';
export const API_PROGRAM_LIST_GET_FAILURE = 'API_PROGRAM_LIST_GET_FAILURE';

export const API_ORG_PROGRAM_GET_REQUEST = 'API_ORG_PROGRAM_GET_REQUEST';
export const API_ORG_PROGRAM_GET_SUCCESS = 'API_ORG_PROGRAM_GET_SUCCESS';
export const API_ORG_PROGRAM_GET_FAILURE = 'API_ORG_PROGRAM_GET_FAILURE';

export const API_PROGRAM_GET_BY_APPROVED_STATUS_REQUEST =
  'API_PROGRAM_GET_BY_APPROVED_STATUS_REQUEST';
export const API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS =
  'API_PROGRAM_GET_BY_APPROVED_STATUS_SUCCESS';
export const API_PROGRAM_GET_BY_APPROVED_STATUS_FAILURE =
  'API_PROGRAM_GET_BY_APPROVED_STATUS_FAILURE';

export const API_ORGS_LIST_GET_BY_ID_REQUEST = 'API_ORGS_LIST_GET_BY_ID_REQUEST';
export const API_ORGS_LIST_GET_BY_ID_SUCCESS = 'API_ORGS_LIST_GET_BY_ID_SUCCESS';
export const API_ORGS_LIST_GET_BY_ID_FAILURE = 'API_ORGS_LIST_GET_BY_ID_FAILURE';
export const DYNAMIC_DATA_GET_ORG_ENTITY_REQUEST = 'DYNAMIC_DATA_GET_ORG_ENTITY_REQUEST';
export const DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS = 'DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS';
export const DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE = 'DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE';

export const ALLOW_ADD_SUB_APPLICATION = 'ALLOW_ADD_SUB_APPLICATION';

export const UPDATE_VERSION = 'UPDATE_VERSION';

export const SET_ORG_ID = 'SET_ORG_ID';
export const SET_DEFAULT_ORG_ID = 'SET_DEFAULT_ORG_ID';
export const SET_SUBAPP_ORG_IDS = 'SET_SUBAPP_ORG_IDS';
export const SET_SUBORGS_ALLOWED = 'SET_SUBORGS_ALLOWED';
export const SAVE_LOCATION_ENTITY = 'SAVE_LOCATION_ENTITY';
export const SAVE_LOCATION_SITE = 'SAVE_LOCATION_SITE';
export const SAVE_LOCATION_SITE_SUCCESS = 'SAVE_LOCATION_SITE_SUCCESS';
export const SAVE_LOCATION_SITE_FAILURE = 'SAVE_LOCATION_SITE_FAILURE';
export const SET_LOCATION_SITE_STORE = 'SET_LOCATION_SITE_STORE';
export const REMOVE_LOCATION_SITE_STORE = 'REMOVE_LOCATION_SITE_STORE';

export const SET_APPLICATION_LINKS = 'SET_APPLICATION_LINKS';
export const ADD_APPLICATION_LINKS = 'ADD_APPLICATION_LINKS';
export const UPDATE_APPLICATION_LINK = 'UPDATE_APPLICATION_LINK';
export const REMOVE_APPLICATION_LINK = 'REMOVE_APPLICATION_LINK';

export const SAVING_NETWORK_ERROR = 'SAVING_NETWORK_ERROR';
export const CLEAR_DYNAMIC_COMPONENT = 'CLEAR_DYNAMIC_COMPONENT';

export const API_USR_GET_ENTITIES_REQUEST = 'API_USR_GET_ENTITIES_REQUEST';
export const API_USR_GET_ENTITIES_SUCCESS = 'API_USR_GET_ENTITIES_SUCCESS';
export const API_USR_GET_ENTITIES_FAILURE = 'API_USR_GET_ENTITIES_FAILURE';

export const AUTOSAVE_REQUEST = 'AUTOSAVE_REQUEST';
export const AUTOSAVE_SUCCESS = 'AUTOSAVE_SUCCESS';
export const AUTOSAVE_FAILURE = 'AUTOSAVE_FAILURE';

export const DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE =
  'DYNAMIC_COMPONENT_FIN_HOLDING_EXCEEDS_FED_SHARE';

export const QUEUE_SAVE = 'QUEUE_SAVE';

export const COLLABORATION_INIT_WITH_STATE_PROXY = 'COLLABORATION_INIT_WITH_STATE_PROXY';
export const COLLABORATION_ENTER_ROOM = 'COLLABORATION_ENTER_ROOM';
export const COLLABORATION_ENTER_ROOM_FETCH_SUCCESS =
  'COLLABORATION_ENTER_ROOM_FETCH_SUCCESS';
export const COLLABORATION_LOCAL_DOCUMENT_UPDATE = 'COLLABORATION_LOCAL_DOCUMENT_UPDATE';
export const COLLABORATION_REMOTE_DOCUMENT_UPDATE =
  'COLLABORATION_REMOTE_DOCUMENT_UPDATE';
export const COLLABORATION_LEAVE_ROOM = 'COLLABORATION_LEAVE_ROOM';
export const COLLABORATION_CLOSE_ALL_ROOMS = 'COLLABORATION_CLOSE_ALL_ROOMS';
export const COLLABORATION_TOGGLE_COLLABORATION = 'COLLABORATION_TOGGLE_COLLABORATION';
export const COLLABORATION_ROOM_LEFT = 'COLLABORATION_ROOM_LEFT';
export const COLLABORATION_ALL_ROOMS_LEFT = 'COLLABORATION_ALL_ROOMS_LEFT';
export const COLLABORATION_REFRESH_ROOM = 'COLLABORATION_REFRESH_ROOM';
export const COLLABORATION_REFETCH_ROOM = 'COLLABORATION_REFETCH_ROOM';
export const COLLABORATION_SUBMISSION = 'COLLABORATION_SUBMISSION';
export const COLLABORATION_SUBMISSION_LOCK = 'COLLABORATION_SUBMISSION_LOCK';
export const COLLABORATION_SUBMISSION_UNLOCK = 'COLLABORATION_SUBMISSION_UNLOCK';
export const COLLABORATION_LOCK_CHANGE = 'COLLABORATION_LOCK_CHANGE';
